export const getTableTranslation = (t) =>
  t || ((value, options) => (options ? value : value));

export const buildTableDefaults = ({
  t,
  emptyMessage,
  loadingMessage,
  emptyMessageKey,
  loadingMessageKey,
  rowClassName = "hover:bg-muted/40",
} = {}) => {
  const translate = getTableTranslation(t);

  return {
    translate,
    emptyMessage:
      emptyMessage ?? translate(emptyMessageKey || "No data found."),
    loadingMessage:
      loadingMessage ?? translate(loadingMessageKey || "Loading..."),
    getRowProps: () => ({ className: rowClassName }),
  };
};
